<template>
	<li class="c-step-by-step__item-wrapper">
		<details class="c-step-by-step__details" :open="isExpanded">
			<summary
				data-step-by-step-activator
				class="c-step-by-step__summary"
				:data-active="isExpanded"
				@click.prevent="emit('expand', index)"
				:aria-expanded="isExpanded"
				:aria-controls="contentId"
			>
				<DsText
					html-element="span"
					text-type="heading-md"
					class="c-step-by-step__item-number"
				>
					<span class="c-step-by-step__item-disc">
						{{ index }}
					</span>
				</DsText>
				<DsText
					class="c-step-by-step__heading"
					text-type="heading-lg"
					text-style="medium"
					html-element="span"
					:id="headingId"
				>
					{{ headline }}
				</DsText>
			</summary>
			<div
				data-step-by-step-content
				class="c-step-by-step__content"
				:id="contentId"
				:data-expanded="isExpanded"
			>
				<div class="c-step-by-step__item-content-wrapper">
					<div class="c-step-by-step__item-media" v-if="!isDesktop">
						<div
							v-if="externalVideoSource"
							class="c-step-by-step__video-container"
						>
							<StepByStepVideoItemLoop
								:is-expanded="isExpanded"
								:video-url="externalVideoSource"
								video-wrapper-class="c-step-by-step__video"
								:video-id="`${id}-${index}`"
							/>
						</div>

						<div v-else class="c-step-by-step__image-container">
							<img
								class="c-step-by-step__image"
								:src="imageUrl"
								:alt="imageAltText"
							/>
						</div>
					</div>

					<div class="c-step-by-step__item-text">
						<DsText
							v-if="isTablet"
							class="c-step-by-step__heading"
							text-type="heading-lg"
							text-style="medium"
							html-element="h3"
							:id="`heading-${id}-${index}`"
						>
							{{ headline }}
						</DsText>

						<DsText
							html-element="div"
							text-type="body-md"
							text-style="regular"
						>
							<div v-html="content"></div>
						</DsText>
					</div>
				</div>
			</div>
		</details>
	</li>
</template>

<script setup lang="ts">
import { computed, inject } from 'vue';
import StepByStepVideoItemLoop from './StepByStepVideoItemLoop.vue';
import { DsText } from '@coloplast/design-system';

type StepByStepItem = {
	id: string;
	index: number;
	isExpanded: boolean;
	headline: string;
	externalVideoSource?: string;
	imageUrl?: string;
	imageAltText?: string;
	content: string;
};

const props = defineProps<StepByStepItem>();

const emit = defineEmits<{
	(e: 'expand', index: number): void;
}>();

const headingId = computed(() => `heading-${props.id}-${props.index}`);
const contentId = computed(() => `content-${props.id}-${props.index}`);

const isDesktop = inject<boolean>('isDesktop', false);
const isTablet = inject<boolean>('isTablet', false);
</script>
